import React, { useState, useEffect, useRef } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Col, Container, Row, Tab } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from 'primereact/checkbox';        
import Table from 'react-bootstrap/Table';
import Laoding from '../shared/Laoding';
import ShowError from "../shared/ShowError";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import * as parameterHelper from '../shared/extraParameterHelper';
import axios from "axios";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Link, Navigate, useNavigate  } from 'react-router-dom';

export default function ProductSelector(props) {
    const navigate = useNavigate();
    const targetRef1 = useRef(null);
    const [applyScroll, setApplyScroll] = useState(1);
    const [laodingProducts, setLaodingProducts] = useState(true);
    const [checkDiscount, setCheckDiscount] = useState(false);
    const [productType, setProductType] = useState('');
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [modulePrice, setModulePrice] = useState(0);
    const [parameterPrice, setParameterPrice] = useState(0);
    const [discountMobile, setDiscountMobile] = useState("");
    const [discountToken, setDiscountToken] = useState("");
    const [discountValue, setDiscountValue] = useState(0);
    const [discountPercent, setDiscountPercent] = useState(0);
    const [maxStudentNo, setMaxStudentNo] = useState(0);
    const [maxMemberNo, setMaxMemberNo] = useState(0);
    const [maxClientNo, setMaxClientNo] = useState(0);
    const [maxSchoolNo, setMaxSchoolNo] = useState(0);
    const [maxBillNo, setMaxBillNo] = useState(0);
    const [maxVisitorNo, setMaxVisitorNo] = useState(0);
    const [activeKey, setActiveKey] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState("");

    useEffect(() => {
        if(applyScroll == 2){
            util.scrollToElement(targetRef1, "center");
            setApplyScroll(3);
            return;
        }
        else if(applyScroll == 3){
            return;
        }
        setLaodingProducts(true);
        var params = {param1:"1", param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/basic/product-prices/list`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                var user = util.getCurrentUser();
                if(user != null){
                    setDiscountMobile(user.mobile);
                }
                response = response.data;
                console.log("resopnse is> ", response);
                var ps = response;
                setProducts(ps);
                setLaodingProducts(false);
                var buy = util.getBuy();
                if(buy == null){
                    var osd = util.getOtherSystemDetail();
                    if(osd.enName != ""){
                        var ak = null;
                        var pc = null;
                        for(var i=0;i<ps.products.length;i++){
                            if(ps.products[i].enName == osd.enName){
                                ak = String(i);
                                pc = ps.products[i];
                                break;
                            }
                        } 
                        console.log("ak is>", ak)
                        setActiveKey(ak);
                    }
                }
                else{
                    var ak = null;
                    var pc = null;
                    for(var i=0;i<ps.products.length;i++){
                        if(ps.products[i].enName == buy.enName){
                            ak = String(i);
                            pc = ps.products[i];
                            break;
                        }
                    } 
                    console.log("ak is>", ak)
                    setActiveKey(ak);
                    
                    if(buy.discountValue && buy.discountValue != null)setDiscountToken(buy.discountToken); 
                    if(buy.discountMobile && buy.discountMobile != null)setDiscountMobile(buy.discountMobile); 
                    onProductSelected(buy.productType, ps, pc, buy.modules, buy.parameters, ps.extraParameters);
                }
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                //setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            //setLoading(false);
        });
    }, [applyScroll]);

    const getSelectedMainProduct = function(fullProducts, value){
        console.log("pt is>", value)
        for(var i=0;i<fullProducts.products.length;i++){
            var p = fullProducts.products[i];
            console.log("p.productProposedOptions is>", p.productProposedOptions)
            for(var j=0;j<p.productProposedOptions.length;j++){
                if(p.productProposedOptions[j].code == value) return fullProducts.products[i];
            }
        }
    }
    const onProductSelected = function(value, fullProducts, pc, modules, parameters, extraParameters){
        console.log("modules is>", modules)
        setProductType(value);
        var res = { };
        var product = null;
        if(!fullProducts) fullProducts = products;
        if(pc) product = pc;
        else product = getSelectedMainProduct(fullProducts, value);
        if(!product) return;
        console.log("product is>", product)
        var modulesState = [];
        for(var i=0;i<product.modules.length;i++){
            var m = {...product.modules[i]};
            m["isChecked"] = m.isMandatory;
            if(!m.isMandatory){
                if(modules){
                    if(modules.includes(m.code))m["isChecked"] = true;
                    else m["isChecked"] = false;
                }
            }
            modulesState.push(m);
        }
        for(var i=0;i<modulesState.length;i++){
            if(modulesState[i].isChecked)continue;
            for(var j=0;j<product.productProposedOptions.length;j++){
                if(product.productProposedOptions[j].code == value){
                    var proposed = product.productProposedOptions[j];
                    for(var k=0;k<proposed.moduleCodes.length;k++){
                        if(modules){

                        }
                        else{
                            if(modulesState[i].code == proposed.moduleCodes[k]){
                                modulesState[i].isChecked = true;
                            }
                        }
                    }
                }
            }
        }
        res["product"] = product;
        res["modulesState"] = modulesState;
        setSelectedProduct(res);
        
        var mp = getModulePrice(res);
        setModulePrice(mp);

        if(parameters){
            setMaxClientNo(parameters.maxClientNo);
            setMaxVisitorNo(parameters.maxVisitorNo);
            setMaxStudentNo(parameters.maxStudentNo);
            setMaxSchoolNo(parameters.maxSchoolNo);
            setMaxMemberNo(parameters.maxMemberNo);
            setMaxBillNo(parameters.maxBillNo);
            
            var pp = 0;
            if(parameters.maxClientNo >0) pp = (parameterHelper.getWinHanaAccountingParameterPrice(parameters.maxClientNo, parameters.maxVisitorNo, extraParameters));
            else if(parameters.maxVisitorNo >0) pp = (parameterHelper.getWinHanaAccountingParameterPrice(parameters.maxClientNo, parameters.maxVisitorNo, extraParameters));

            else if(parameters.maxStudentNo >0) pp = (parameterHelper.getSchoolManagementParameterPrice(parameters.maxStudentNo, parameters.maxSchoolNo, extraParameters));
            else if(parameters.maxSchoolNo >0) pp = (parameterHelper.getSchoolManagementParameterPrice(parameters.maxStudentNo, parameters.maxSchoolNo, extraParameters));

            else if(parameters.maxMemberNo >0) pp = (parameterHelper.getSandooghManagementParameterPrice(parameters.maxMemberNo, extraParameters));
            
            else if(parameters.maxBillNo >0) pp = (parameterHelper.getTaxServiceParameterPrice(parameters.maxBillNo, extraParameters));

            else pp = (0);

            setParameterPrice(pp);
            var value = 0;
            value = Math.floor(((res.product.basePrice + mp + pp)*discountPercent)/100);
            setDiscountValue(value);
        }
        else{
            setMaxClientNo(0);
            setMaxVisitorNo(0);
            setMaxStudentNo(0);
            setMaxSchoolNo(0);
            setMaxMemberNo(0);
            setMaxBillNo(0);
            var pp = 0;
            setParameterPrice(pp);
            var value = 0;
            value = Math.floor(((res.product.basePrice + mp + pp)*discountPercent)/100);
            setDiscountValue(value);
        }
        setApplyScroll(2);
        console.log("selected product is>", res);
        
    }
    const getModulePrice = function(selectedProduct){
        var res = 0;
        for(var i=0;i<selectedProduct.modulesState.length;i++){
            if(selectedProduct.modulesState[i].isChecked){
                res += selectedProduct.modulesState[i].price;
            }
        }
        return res;
    }
    const getParameterPrice = function(selectedProduct){
        var res = 0;        
        if(selectedProduct.product.productType.id == util.ProductTypes.WinHanaAccounting){
            res = parameterHelper.getWinHanaAccountingParameterPrice(maxClientNo, maxVisitorNo, products.extraParameters);
        }
        else if(selectedProduct.product.productType.id == util.ProductTypes.SchoolManagment){
            res = parameterHelper.getSchoolManagementParameterPrice(maxStudentNo, maxSchoolNo, products.extraParameters);
        }
        else if(selectedProduct.product.productType.id == util.ProductTypes.SandooghManagment){
            res = parameterHelper.getSandooghManagementParameterPrice(maxMemberNo, products.extraParameters);
        }
        else if(selectedProduct.product.productType.id == util.ProductTypes.TaxSerivce){
            res = parameterHelper.getTaxServiceParameterPrice(maxBillNo, products.extraParameters);
        }
        return res;
    }
    const onModuleCheckChanged = (code, value, ind) => {
        var res = {...selectedProduct};
        res.modulesState[ind].isChecked = !value;
        setSelectedProduct(res);
        var mp = getModulePrice(res);
        var pp = getParameterPrice(res);
        setModulePrice(mp);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((selectedProduct.product.basePrice + mp + pp)*discountPercent)/100);
        setDiscountValue(value);
    };    

    const onMaxClientNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxClientNo(v);
        var pp = parameterHelper.getWinHanaAccountingParameterPrice(v, maxVisitorNo, products.extraParameters);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((selectedProduct.product.basePrice + modulePrice + pp)*discountPercent)/100);
        setDiscountValue(value);
    }

    const onMaxVisitorNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxVisitorNo(v);
        var pp = parameterHelper.getWinHanaAccountingParameterPrice(maxClientNo, v, products.extraParameters);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((selectedProduct.product.basePrice + modulePrice + pp)*discountPercent)/100);
        setDiscountValue(value);
    }
    const onMaxStudentNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxStudentNo(v);
        setMaxSchoolNo(0);
        var pp = parameterHelper.getSchoolManagementParameterPrice(v, 0, products.extraParameters);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((selectedProduct.product.basePrice + modulePrice + pp)*discountPercent)/100);
        setDiscountValue(value);
    }
    const onMaxSchoolNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxStudentNo(0);
        setMaxSchoolNo(v);
        var pp = parameterHelper.getSchoolManagementParameterPrice(0, v, products.extraParameters);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((selectedProduct.product.basePrice + modulePrice + pp)*discountPercent)/100);
        setDiscountValue(value);
    }
    const onMaxMemberNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxMemberNo(v);
        var pp = parameterHelper.getSandooghManagementParameterPrice(v, products.extraParameters);
        setParameterPrice(pp);
        var value = 0;
        value = Math.floor(((selectedProduct.product.basePrice + modulePrice + pp)*discountPercent)/100);
        setDiscountValue(value);

    }
    const onMaxBillNoChanged = (value) =>{
        var v = 0;
        if(isNaN(value)) v = 0;
        else if(value == null) v = 0;
        else if(value == "") v = 0;
        else v = parseInt(value);
        setMaxBillNo(v);
        setParameterPrice(parameterHelper.getTaxServiceParameterPrice(v, products.extraParameters));
    }
    const checkDiscountToken = () =>{
        if(discountToken.length <12){
            setErorVisible(true);
            setErrorMessage("کد تخفیف باید حداقل 12 حرف یا رقم باشد");
            return;
        }
        // var check = util.IsMobileValid(discountMobile);
        // if(!check.valid){
        //     setErorVisible(true);
        //     setErrorMessage(check.msg);
        //     return;
        // }
        setCheckDiscount(true);
        var params = {login:{}, code:discountToken, mobile:discountMobile};
        var url = config.Server+`/payment/discount-token/check`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setDiscountPercent(response);
                var value = 0;
                value = Math.floor(((selectedProduct.product.basePrice + modulePrice + parameterPrice)*response)/100);
                setDiscountValue(value);
                setCheckDiscount(false);
                
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setCheckDiscount(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setCheckDiscount(false);
        });
    }
    const mainProductSelected = (key)=>{
        if(key == null){
            setSelectedProduct(null);
            deleteBuyFromLocal();
        }
        else{
            if(products.products[key].productProposedOptions.length == 1){
                onProductSelected(products.products[key].productProposedOptions[0].code);
            }
            else{
                setSelectedProduct(null);
                deleteBuyFromLocal();
            }
        }
        setActiveKey(key);
    }
    const saveBuyInLocal = ()=>{
        var modules = [];
        for(var i=0;i<selectedProduct.modulesState.length;i++){
            if(selectedProduct.modulesState[i].isChecked){
                modules.push(selectedProduct.modulesState[i].code);
            }
        }
        var buy = {
            productId:selectedProduct.product.id,
            enName:selectedProduct.product.enName,
            buyGoal:"buyContract",
            productType:productType,
            modules:modules,
            parameters :{
                maxClientNo:maxClientNo,
                maxVisitorNo:maxVisitorNo,
                maxStudentNo:maxStudentNo,
                maxSchoolNo:maxSchoolNo,
                maxMemberNo:maxMemberNo,
                maxBillNo:maxBillNo
            },
            price:(selectedProduct.product.basePrice + modulePrice + parameterPrice - discountValue),
            discountToken:discountToken,
            discountMobile:discountMobile,

        };
        util.saveBuy(buy);
        setRedirectUrl("/get-company-detail");
    }
    const deleteBuyFromLocal = ()=>{
        util.deleteBuy();
    }
    const onContinueButtonClick = ()=>{
        if((selectedProduct.product.productType.id == util.ProductTypes.SchoolManagment)&&(productType == "independent_school")){
            if(maxStudentNo <=0){
                setErorVisible(true);
                setErrorMessage("حداکثر تعداد دانش آموزان را مشخص نمائید");
                return;
            }
        }
        else if((selectedProduct.product.productType.id == util.ProductTypes.SchoolManagment)&&(productType == "complex_school")){
            if(maxSchoolNo <=0){
                setErorVisible(true);
                setErrorMessage("حداکثر تعداد مدارس را مشخص نمائید");
                return;
            }
        }
        else if(selectedProduct.product.productType.id == util.ProductTypes.SandooghManagment){
            if(maxMemberNo <=0){
                setErorVisible(true);
                setErrorMessage("حداکثر تعداد اعضاء را مشخص نمائید");
                return;
            }
        }
        else if(selectedProduct.product.productType.id == util.ProductTypes.TaxSerivce){
            if(maxBillNo <=0){
                setErorVisible(true);
                setErrorMessage("حداکثر تعداد صورتحساب در سال را مشخص نمائید");
                return;
            }
        }
        saveBuyInLocal();
    }
    return (
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :        
        laodingProducts?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال دریافت لیست محصولات..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
        <Row style={{margin:"20px 0px 0px 0px", padding:"0px"}}>
            <Col>
                <h3>محصول مورد نظر را انتخاب نمائید</h3>
            </Col>
        </Row>
        <Row style={{margin:"10px 0px", padding:"0px"}}>
            <Col md="4" style={{margin:"0px", padding:"5px", boxSizing:"border-box"}}>
                <Accordion style={{width: "calc(100% - 7px)"}} key={"AccordionMain"} activeKey={activeKey} onSelect={(key) => mainProductSelected(key)}>
                    {
                        products.products.map((product, productIndex)=>{
                            return(
                                <Accordion.Item eventKey={String(productIndex)} key={String(productIndex)}>
                                    <Accordion.Header key={"Header" + String(productIndex)}><b>{product.productType.title}</b></Accordion.Header>
                                    <Accordion.Body key={"body" + String(productIndex)}>
                                        <Row>
                                            <div style={{backgroundColor:"rgb(253, 253, 236)", border:"1px dashed #b0b0b0", borderRadius:"5px", padding:"5px"}}>{product.shortDescription}</div>
                                            <div style={{margin:"10px 0px"}}>نوع فروشگاه، شرکت یا موسسه خود را انتخاب نمائید</div>
                                            <Table hover key={"table" + String(productIndex)}>
                                                <tbody key={"body" + String(productIndex)}>
                                                    {
                                                        product.productProposedOptions.map((propos, proposIndex)=>{
                                                            return(
                                                    <tr key={"tr_" + String(productIndex) + "_" + String(proposIndex)}>
                                                        <td style={{borderBottom:"0px"}} key={"td_" + String(productIndex) + "_" + String(proposIndex)}>
                                                            <div className="flex align-items-center" style={{padding:"5px"}}>
                                                                <RadioButton inputId={"ingredient_"+productIndex+"_"+proposIndex} name="product_proposed" value={propos.code} onChange={(e) => {onProductSelected(e.value)}} checked={productType === propos.code} />
                                                                <label htmlFor={"ingredient_"+productIndex+"_"+proposIndex} className="ml-2">&nbsp;{propos.title}</label>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                            <div style={{backgroundColor:"rgb(244, 251, 240)", border:"1px dashed #b0b0b0", borderRadius:"5px", padding:"5px"}}>{product.longDescription}</div>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        })
                    }
                </Accordion>
            </Col>
            {
                (selectedProduct == null)?<></>:
                <>
                    <Col md="4" style={{margin:"0px", padding:"5px", boxSizing:"border-box"}}>
                        <div style={{border:"1px solid #b0b0b0", borderRadius:"5px"}} ref={targetRef1}>
                            <div style={{backgroundColor:"#ccddff", padding:"12px"}}>انتخاب ماژول های مورد نیاز</div>
                            <div style={{padding:"10px 0px 2px 0px"}}>
                                <div style={{padding:"5px"}}>شما محصول [<label style={{color:"rgb(8, 106, 8)", fontWeight:"bold"}}>{selectedProduct.product.productType.title}</label>] را انتخاب نموده اید</div>
                                <div style={{padding:"5px"}}>ماژول های مورد نیاز را نیز انتخاب کنید</div>
                                <Table hover striped key={"moduletable"}>
                                    <tbody  key={"moduletablebody"}>
                                    {
                                        selectedProduct.modulesState.map((m, mInd)=>{
                                            return(
                                                <tr key={"tr_" + String(mInd)}>
                                                    <td style={{borderBottom:"0px"}} key={"td1_" + String(mInd)}>
                                                        <div key={"divCheckBox_"+String(mInd)} className="flex align-items-center">
                                                            <Checkbox disabled={m.isMandatory} value={m.isChecked} inputId={"chkModule_"+String(mInd)} onChange={(e)=>onModuleCheckChanged(m.code, e.value, mInd)} checked={m.isChecked} />
                                                            <label htmlFor={"chkModule_"+String(mInd)} className="ml-2">&nbsp;{m.title}</label>
                                                        </div>
                                                    </td>
                                                    <td style={{borderBottom:"0px"}} key={"td2_" + String(mInd)}>
                                                        {util.SeperatePrice(m.price)}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </Table>
                                <table style={{width:"100%"}}>
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px", width:"50%"}}>جمع ماژول ها</td>
                                            <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px", width:"50%"}}>{util.SeperatePrice(modulePrice)}</td>
                                        </tr>
                                    </tbody>
                                </table> 
                            </div>
                        </div>        
                    </Col>
                    <Col md="4" style={{margin:"0px", padding:"5px", boxSizing:"border-box"}}>
                        <div style={{border:"1px solid #b0b0b0", borderRadius:"5px"}}>
                            <div style={{backgroundColor:"#ccddff", padding:"12px"}}>تنظیم پارامترها</div>
                            <div style={{padding:"10px 0px 10px 0px"}}>
                                <Table hover striped key={"parametertable"}>
                                    <tbody  key={"parametertablebody"}>
                                    {
                                        (selectedProduct.product.productType.id == util.ProductTypes.WinHanaAccounting)?
                                        <>
                                        <tr>
                                            <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد دستگاه برای نصب</td>
                                            <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                <InputText value={maxClientNo} onChange={(e) => onMaxClientNoChanged(e.target.value)} keyfilter="int" style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد ویزیتور</td>
                                            <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                <InputText value={maxVisitorNo} onChange={(e) => onMaxVisitorNoChanged(e.target.value)} keyfilter="int" style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                            </td>
                                        </tr>
                                        </>
                                        :<></>
                                    }
                                    {
                                        ((selectedProduct.product.productType.id == util.ProductTypes.SchoolManagment)&&(productType == "independent_school"))?
                                        <>
                                        <tr>
                                            <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>حداکثر تعداد دانش آموز</td>
                                            <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                <InputText value={maxStudentNo} onChange={(e) => onMaxStudentNoChanged(e.target.value)} keyfilter="int" style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                            </td>
                                        </tr>
                                        </>
                                        :
                                        <></>
                                    }
                                    {
                                        ((selectedProduct.product.productType.id == util.ProductTypes.SchoolManagment)&&(productType == "complex_school"))?
                                        <>
                                        <tr>
                                            <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تعداد مدارس تابعه</td>
                                            <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                <InputText value={maxSchoolNo} onChange={(e) => onMaxSchoolNoChanged(e.target.value)} keyfilter="int" style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={4} />
                                            </td>
                                        </tr>
                                        </>
                                        :
                                        <></>
                                    }
                                    {
                                        (selectedProduct.product.productType.id == util.ProductTypes.SandooghManagment)?
                                        <>
                                        <tr>
                                            <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>حداکثر تعداد اعضای صندوق</td>
                                            <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                <InputText value={maxMemberNo} onChange={(e) => onMaxMemberNoChanged(e.target.value)} keyfilter="int" style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={5} />
                                            </td>
                                        </tr>
                                        </>
                                        :
                                        <></>
                                    }
                                    {
                                        (selectedProduct.product.productType.id == util.ProductTypes.TaxSerivce)?
                                        <>
                                        <tr>
                                            <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>حداکثر تعداد فاکتور در سال</td>
                                            <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                <InputText value={maxBillNo} onChange={(e) => onMaxBillNoChanged(e.target.value)} keyfilter="int" style={{width:"80px", textAlign:"center", direction:"ltr"}} maxLength={5} />
                                            </td>
                                        </tr>
                                        </>
                                        :
                                        <></>
                                    }
                                    </tbody>
                                </Table>
                                <Table key={"discounttable"} style={{marginTop:"50px"}}>
                                    <tbody  key={"discounttablebody"}>
                                        <tr><td colSpan={2}>در صورتی که توکن تخفیف در اختیار دارید جهت بررسی و استفاده، مشخصات آنرا در کاردرهای زیر وارد کنید</td></tr>
                                        <tr>
                                            <td style={{width:"50%", textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>کد تخفیف</td>
                                            <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                <InputText value={discountToken} onChange={(e) => {setDiscountToken(e.target.value); setDiscountValue(0);}} style={{width:"160px", textAlign:"center", direction:"ltr"}} maxLength={20} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign:"left", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>مبلغ تخفیف</td>
                                            <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>
                                                {util.SeperatePrice(discountValue) + " ("+discountPercent+"%)"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign:"center", verticalAlign:"middle", padding:"5px", border:"1px dashed #b0b0b0"}} colSpan={2}>
                                                <Button severity="Primary" loading={checkDiscount} onClick={()=>{checkDiscountToken()}} style={{borderRadius:"5px"}}>بررسی کد تخفیف</Button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <table style={{width:"100%"}}>
                                    <tbody>
                                        <tr>
                                            <td style={{width:"50%", textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>قیمت پایه</td>
                                            <td style={{width:"50%", textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(selectedProduct.product.basePrice)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>جمع ماژول ها</td>
                                            <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(modulePrice)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>سایر پارامتر ها</td>
                                            <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(parameterPrice)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign:"left", padding:"5px", border:"1px dashed #b0b0b0", borderRight:"0px"}}>تخفیف</td>
                                            <td style={{textAlign:"right", padding:"5px", border:"1px dashed #b0b0b0", borderLeft:"0px"}}>{util.SeperatePrice(discountValue) + " ("+discountPercent+"%)"}</td>
                                        </tr>
                                        <tr>
                                            <td style={{textAlign:"left", padding:"10px", border:"1px dashed #b0b0b0", borderRight:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>جمع کل</td>
                                            <td style={{textAlign:"right", padding:"10px", border:"1px dashed #b0b0b0", borderLeft:"0px", backgroundColor:"#505050", color:"#FFF", fontSize:"1.3rem"}}>{util.SeperatePrice(selectedProduct.product.basePrice + modulePrice + parameterPrice - discountValue)}</td>
                                        </tr>
                                    </tbody>
                                </table> 
                                <div style={{padding:"5px", textAlign:"center"}}>
                                    <Button severity="success" loading={checkDiscount} onClick={()=>{onContinueButtonClick()}} style={{borderRadius:"5px"}}>&nbsp;&nbsp;تائید محصول و ادامه&nbsp;&nbsp;</Button>
                                </div>                               
                                <div style={{padding:"5px", textAlign:"center"}}>
                                    مالیات ارزش افزوده نیز مطابق قوانین به مبلغ فوق اضافه می گردد
                                </div>                               
                            </div>
                        </div>
                    </Col>
                </>
            }
        </Row>

        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
    </>

    )
}
